import React from 'react';

const InvoiceFormSection = ({ formData, handleInputChange, cardStyle, cardHeaderStyle, inputStyle, labelStyle }) => {
  return (
    <div style={cardStyle}>
      <div style={cardHeaderStyle}>
        Dane faktury
      </div>
      <div style={{ padding: '0.75rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', marginBottom: '0.5rem' }}>
          <div>
            <label style={labelStyle}>Numer faktury *</label>
            <input
              type="text"
              value={formData.numer_faktury}
              onChange={(e) => handleInputChange('numer_faktury', e.target.value)}
              style={inputStyle}
              placeholder="FZ/001/2024"
            />
          </div>
          <div>
            <label style={labelStyle}>Data faktury *</label>
            <input
              type="date"
              value={formData.data_faktury}
              onChange={(e) => handleInputChange('data_faktury', e.target.value)}
              style={inputStyle}
            />
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem', marginBottom: '0.5rem' }}>
          <div>
            <label style={labelStyle}>Data dostawy</label>
            <input
              type="date"
              value={formData.data_dostawy}
              onChange={(e) => handleInputChange('data_dostawy', e.target.value)}
              style={inputStyle}
            />
          </div>
          <div>
            <label style={labelStyle}>Termin platnosci</label>
            <input
              type="date"
              value={formData.data_platnosci}
              onChange={(e) => handleInputChange('data_platnosci', e.target.value)}
              style={inputStyle}
            />
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.5rem' }}>
          <div>
            <label style={labelStyle}>Sposob platnosci</label>
            <select
              value={formData.sposob_platnosci}
              onChange={(e) => handleInputChange('sposob_platnosci', e.target.value)}
              style={inputStyle}
            >
              <option value="przelew">Przelew</option>
              <option value="gotowka">Gotowka</option>
              <option value="karta">Karta</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>Waluta</label>
            <select
              value={formData.waluta}
              onChange={(e) => handleInputChange('waluta', e.target.value)}
              style={inputStyle}
            >
              <option value="PLN">PLN</option>
              <option value="EUR">EUR</option>
              <option value="USD">USD</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>Status</label>
            <select
              value={formData.status}
              onChange={(e) => handleInputChange('status', e.target.value)}
              style={inputStyle}
            >
              <option value="nowa">Nowa</option>
              <option value="oczekujaca">Oczekujaca</option>
              <option value="zatwierdzona">Zatwierdzona</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceFormSection;
